import { sanityWebsiteClient } from '../sanityWebsiteClient';

interface FriendbuyPage {
	seoTitle: string | null;
	seoDescription: string | null;
}

interface FriendbuyContent {
	bannerLabel: string;
}

export function getFriendbuypage(): Promise<FriendbuyPage> {
	return sanityWebsiteClient.fetch(`*[_type == "friendbuy"] { seoTitle, seoDescription }[0]`);
}

export function getFriendbuyContent(): Promise<FriendbuyContent> {
	return sanityWebsiteClient.fetch(`*[_type == "friendbuy"] { bannerLabel }[0]`);
}
